import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { DeleteMenu } from "../../../services/menu.service";

interface Props {
  openDelCategory: boolean;
  setOpenDelCategory: any;
  rowInfo: any;
  setUpdateTree: any;
}
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },

  maxHeight: "70vh",
  minHeight: "15vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const DelMenuModal = ({
  openDelCategory,
  setOpenDelCategory,
  rowInfo,
  setUpdateTree,
}: Props) => {
  const handleDelete = () => {
    DeleteMenuMutate({
      id: rowInfo.node.id,
    });
  };

  const { mutate: DeleteMenuMutate } = useMutation(DeleteMenu, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenDelCategory(false);
        setUpdateTree(uuid());
      }
    },
    onError: () => {},
  });

  return (
    <div>
      <Modal
        open={openDelCategory}
        onClose={() => {
          setOpenDelCategory(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"3.8rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                fontSize={"14px"}
              >
                {/* this part must be dynamic */}
                آیا از حذف گروه بندی{" "}
                <span style={{ color: "#E6123D" }}>
                  " {rowInfo?.node.title} "
                </span>{" "}
                اطمینان دارید؟
              </Typography>
            </Grid>
            <Grid item width={"100%"}>
              <Grid
                container
                flexDirection={"row"}
                justifyContent={"center"}
                gap={"1rem"}
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{
                      height: "40px",
                      color: "#fff",
                      background: "#E6123D",
                      fontWeight: "bold",
                      "&:hover": {
                        background: "#E6123D",
                      },
                    }}
                    onClick={handleDelete}
                  >
                    بله
                  </Button>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={6}
                  maxWidth={"150px !important"}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    style={{
                      fontSize: "1rem",
                      color: "#fff",
                      height: "40px",
                      background: "#607D8B",
                    }}
                    onClick={() => {
                      setOpenDelCategory(false);
                    }}
                  >
                    خیر
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default DelMenuModal;
